import { getItineraryDueDate } from './itinerary';
import moment from 'moment';

export { achMandatePrompt, achMandateRecord } from './achMandate';

export const PAYMENT_TYPE = {
  BALANCE: 'balance',
  DEPOSIT: 'deposit',
  SELL: 'sell',
};

// The deposit an enquire/book-now itinerary asks for when neither the itinerary nor its
// agency names its own. Cents; amount + serviceFee = $1,500.
export const DEFAULT_ENQUIRE_DEPOSIT = {
  amount: 144750,
  serviceFee: 5250,
};

export const PAYMENT_STATUS = {
  ERROR: 'Error',
  AUTH: 'Authorized',
  PAID: 'Paid',
  PENDING: 'Pending',
};

export const PAYMENT_METHOD = {
  ACH: 'ach',
  BNPL: 'bnpl',
  CREDIT: 'credit',
  DIRECT_DEBIT: 'direct_debit',
  WIRE: 'wire',
};

export const PAYMENT_PROCESSOR = {
  STRIPE: 'Stripe',
  FLYWIRE: 'Flywire',
  UPLIFT: 'Uplift',
  WIRE: 'Wire',
};

export const DISCOUNT_ELIGIBLE_METHODS = [PAYMENT_METHOD.ACH, PAYMENT_METHOD.WIRE, PAYMENT_METHOD.DIRECT_DEBIT];

// Payment methods supported by the Payment.reversePayment endpoint. Reversal is
// processor-agnostic — the math is decided by paymentMethod, and the out-of-band
// refund (Stripe dashboard, Flywire portal, Uplift loan cancellation, bank reversal)
// is the SuperAdmin's responsibility.
export const REVERSIBLE_PAYMENT_METHODS = [
  PAYMENT_METHOD.CREDIT,
  PAYMENT_METHOD.ACH,
  PAYMENT_METHOD.DIRECT_DEBIT,
  PAYMENT_METHOD.BNPL,
  PAYMENT_METHOD.WIRE,
];

const reversiblePaymentMethodSet = new Set(REVERSIBLE_PAYMENT_METHODS);

export const isReversiblePayment = payment => {
  if (!payment) return false;
  return reversiblePaymentMethodSet.has(payment.paymentMethod);
};

export const DIRECT_DEBIT_TYPE = {
  EUR: 'SEPA',
  GBP: 'BACS',
  CAD: 'EFT',
  ZAR: 'EFT',
  USD: 'ACH',
};

export const DIRECT_DEBIT_LABEL = Object.fromEntries(
  Object.entries(DIRECT_DEBIT_TYPE).map(([currency, type]) => [currency, `Direct Debit (${type})`]),
);

export const ACH_DESCRIPTOR_LENGTH = 22;
export const CC_DESCRIPTOR_LENGTH = 15;

export const paymentMethodDisplay = paymentMethod => {
  switch (paymentMethod) {
    case PAYMENT_METHOD.ACH:
      return 'ACH';
    case PAYMENT_METHOD.CREDIT:
      return 'Credit Card';
    case PAYMENT_METHOD.WIRE:
      return 'Wire Transfer';
    case PAYMENT_METHOD.BNPL:
      return 'Pay Monthly';
    case PAYMENT_METHOD.DIRECT_DEBIT:
      return 'Direct Debit';
    default:
      return '';
  }
};

// Get the due date for an itinerary and paymentType
export const getPaymentDueDate = (itinerary, paymentType) =>
  paymentType === PAYMENT_TYPE.DEPOSIT ? moment().utc().startOf('day') : getItineraryDueDate(itinerary);

export const sanitizeDescriptor = (descriptor = '', maxLength) => {
  const sanitized = descriptor.replace(/['<>]/g, '').slice(0, maxLength);
  return sanitized || undefined;
};

export const paymentDefaultName = (itinerary, payment) => payment.name ?? [itinerary.name, payment.paymentType].filter(Boolean).join(' ');
